module.exports = __webpack_public_path__ + "img/twitter.1bda30db.svg";